import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { AuthProvider } from "react-oidc-context";

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_AUTHORITY!,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID!,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI!,
  response_type: "code",
  scope: "phone openid email",
  post_logout_redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI!,
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
  loadUserInfo: true,
  automaticSilentRenew: true,
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);